// SocialMediaIcons.js

const SocialMediaIcons = (props) => {
    const {isFooter} = props;
    
    return (
        <div className="sm-icons">
            <ul>
                <li>
                    <a href="https://www.facebook.com/ajitfurniturehouse" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook" aria-hidden="true"></i><span className="sr-only">Open Facebook page</span></a>
                </li>
                
                <li>
                    <a href="https://www.instagram.com/ajitfurniturehouse" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram" aria-hidden="true"></i><span className="sr-only">Open Instagram page</span></a>
                </li>

                {/* <li>
                    <a href="mailto:ajitfurniture33@yahoo.com" target="_blank" rel="noopener noreferrer"><i className="fas fa-envelope-square" aria-hidden="true"></i><span className="sr-only">Send email to Ajit Furniture House</span></a>
                </li> */}

                <li className={isFooter ? 'sm-icons__hide' : ''}>
                    <a href="https://g.page/ajitfurniturehouse" target="_blank" rel="noopener noreferrer"><i className="fas fa-map-marker-alt" aria-hidden="true"></i><span className="sr-only">Directions to Ajit Furniture House</span></a>
                </li>

                <li className={isFooter ? 'sm-icons__hide' : ''}>
                    <a href="tel: +91 9650165000" target="_blank" rel="noopener noreferrer"><i className="fas fa-phone-alt" aria-hidden="true"></i><span className="sr-only">Call Ajit Furniture House</span></a>
                </li>

                {/* <li>
                    <a href="https://api.whatsapp.com/send?phone=919650165000" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp" aria-hidden="true"></i><span className="sr-only">Chat with Ajit Furniture House on WhatsApp</span></a>
                </li> */}
            </ul>
        </div>
    )
}

export default SocialMediaIcons;